import { z } from "zod";


export const IndiceReajusteCadastroSchema = z.object({
    idIndiceReajuste: z.number().optional(),
    descricao: z.coerce.string(),
    dataCadastro: z.coerce.date(),
    status: z.coerce.boolean().default(true)


});

export type IndiceReajusteCadastroForm = z.infer<typeof IndiceReajusteCadastroSchema>;

export const defaultIndiceReajusteCadastroForm: Partial<IndiceReajusteCadastroForm> = {
    status: true,

}